"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconLanguage = function IconLanguage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M13.309 19.894a8 8 0 0 1-2.618 0A7.6 7.6 0 0 1 10.1 18.7c-.306-.765-.563-1.678-.751-2.7h5.302c-.188 1.022-.445 1.935-.751 2.7-.188.47-.388.867-.591 1.194M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-2.617-2.438c-.449-.97-.81-2.185-1.05-3.562H5.07a8.02 8.02 0 0 0 4.313 3.562M4.582 15h3.601A24 24 0 0 1 8 12c0-1.045.064-2.053.183-3H4.582A8 8 0 0 0 4 12c0 1.06.207 2.074.582 3m.488-7h3.263c.24-1.377.601-2.592 1.05-3.562A8.03 8.03 0 0 0 5.07 8m5.621-3.893A7.6 7.6 0 0 0 10.1 5.3c-.306.765-.563 1.678-.751 2.7h5.302c-.188-1.022-.445-1.935-.751-2.7a7.6 7.6 0 0 0-.591-1.193 8 8 0 0 0-2.618 0m3.926.331c.449.97.81 2.185 1.05 3.562h3.263a8.03 8.03 0 0 0-4.312-3.562M19.42 9h-3.602c.119.947.183 1.955.183 3s-.064 2.053-.183 3h3.602c.375-.926.581-1.94.581-3s-.206-2.074-.581-3m-.49 7a8.02 8.02 0 0 1-4.311 3.562c.448-.97.809-2.185 1.05-3.562zM15 12c0 1.055-.068 2.063-.191 3H9.19A23 23 0 0 1 9 12c0-1.055.068-2.063.191-3h5.618c.123.937.191 1.945.191 3",
    clipRule: "evenodd"
  })));
};

export { IconLanguage, IconLanguage as default };
